/* nini お問い合わせページ 補助スクリプト
   - 送信中状態と二重送信防止
   - エラー時: サマリーへフォーカス
   - 成功時: メッセージへスクロール
   JSが無効でもフォームはそのまま送信できる(プログレッシブエンハンスメント)。 */
(function () {
  'use strict';

  function init(root) {
    var form = root.querySelector('.nini-contact__form');
    if (form && form.dataset.niniContactInit !== '1') {
      form.dataset.niniContactInit = '1';
      form.addEventListener('submit', function (event) {
        var button = form.querySelector('[data-nini-contact-submit]');
        if (!button) return;
        if (form.dataset.submitting === '1') {
          event.preventDefault();
          return;
        }
        form.dataset.submitting = '1';
        button.classList.add('is-loading');
        button.setAttribute('aria-disabled', 'true');
        var status = button.querySelector('[data-nini-submit-status]');
        if (status) status.textContent = '送信中です';
        // 送信リクエスト開始後に無効化(値の送信を妨げない)
        window.setTimeout(function () {
          button.disabled = true;
        }, 0);
      });
    }

    var errorSummary = root.querySelector('[data-nini-contact-error]');
    if (errorSummary && errorSummary.dataset.niniHandled !== '1') {
      errorSummary.dataset.niniHandled = '1';
      errorSummary.focus({ preventScroll: false });
      var firstErrorField = root.querySelector('.nini-contact__field.has-error input, .nini-contact__field.has-error textarea');
      if (firstErrorField) firstErrorField.focus();
    }

    var success = root.querySelector('[data-nini-contact-success]');
    if (success && success.dataset.niniHandled !== '1') {
      success.dataset.niniHandled = '1';
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      success.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
      success.focus({ preventScroll: true });
    }
  }

  function boot() {
    document.querySelectorAll('.nini-contact').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.nini-contact');
    if (root) init(root);
  });
})();
